import { jsx as i } from "../../_virtual/jsx-runtime.mjs";
import * as t from "react";
import { w as e } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import { playBtn as a, sizeMap as c, icon as s } from "./css/Media.css.mjs";
import p from "../../packages/basic/dist/es/components/ReoIcon/ReoIcon.mjs";
import "../../packages/basic/dist/es/components/ReoBalloon/ReoBalloon.mjs";
import "../../packages/basic/dist/es/components/ReoButton/index.mjs";
import "../../packages/basic/dist/es/components/ReoCheckbox/index.mjs";
import "../../packages/basic/dist/es/components/ReoLink/ReoLink.mjs";
import "../../packages/basic/dist/es/_virtual/jsx-runtime.mjs";
import "../../packages/basic/dist/es/depend/classnames/index.mjs";
import "../../packages/basic/dist/es/assets/css/globalTheme.mjs";
import "../../packages/basic/dist/es/assets/css/themes/template/templateMap.mjs";
import "../../packages/basic/dist/es/components/ReoTabs/ReoTabTree.mjs";
import "../../packages/basic/dist/es/components/ReoInput/index.mjs";
import "../../packages/basic/dist/es/components/ReoSelect/ReoSelect.mjs";
import "../../packages/basic/dist/es/components/ReoPopup/ReoPopup.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/UploadList.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/const.mjs";
import "../../packages/basic/dist/es/depend/rc-upload/es/Upload.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/DraggedUploadList.mjs";
import "../../packages/basic/dist/es/components/ReoAccordion/AccordionItem.mjs";
import "../../packages/basic/dist/es/depend/swiper/swiper-react.mjs";
import "../../packages/basic/dist/es/Basic/LoadingBar/LoadingBar.mjs";
import "../../packages/basic/dist/es/components/ReoMessage/ReoMessage.mjs";
import "../../packages/basic/dist/es/components/ReoForm/index.mjs";
import l from "../../depend/classnames/index.mjs";
const m = (o) => {
  const r = t.useCallback(() => {
    o.onClick();
  }, [o]), n = t.useMemo(
    () => l(a, o.className, c[o.size]),
    [o.className, o.size]
  );
  return /* @__PURE__ */ i(
    "div",
    {
      className: n,
      style: o.style,
      onClick: r,
      children: /* @__PURE__ */ i(
        p,
        {
          className: s,
          color: "#ffffff",
          width: "var(--icon-size)",
          name: o.name
        }
      )
    }
  );
}, G = (o) => /* @__PURE__ */ i(
  m,
  {
    ...o,
    name: "icon-icon_play-2"
  }
), H = (o) => /* @__PURE__ */ i(
  m,
  {
    ...o,
    name: "icon-icon-new-replay"
  }
), J = (o) => /* @__PURE__ */ i(
  m,
  {
    ...o,
    name: "icon-icon-pause-new"
  }
);
e(m, {});
export {
  J as PauseIcon,
  G as PlayIcon,
  H as ReplayIcon
};
//# sourceMappingURL=Icon.mjs.map
